import { SET_CONFIDENTIAL } from "redux/types";

const setConfidential = (payload) => {
  return { type: SET_CONFIDENTIAL, payload };
};

export { setConfidential };
